<template>
<div id="login" class="loginbg">
    <v-content>
        <v-layout> 
            <v-flex xs12>
                <a href="https://loadmax.com" > <img src="/static/loadmaxlogo.png" alt="LoadMax" height="40" class="lgImg"></a>
            </v-flex>
        </v-layout> 
        <v-container fluid fill-height class="">
            <v-layout align-center justify-center> 
                <v-flex xs12 sm8 md3 lg3>
                    <v-card class="elevation-1 pa-3">
                        <v-card-text>
                            <div class="layout column ">
                                <h1 class="flex">Email Confirmation</h1>
                            </div>
                            <v-alert 
                                v-if="responseMsg != '' && responseColor == 'green'"
                                :value="true"
                                type="success"
                            >
                                {{responseMsg}}
                            </v-alert>
                            <v-alert 
                                v-if="responseMsg != '' && responseColor == 'red'"
                                :value="true"
                                type="error"
                            >
                                {{responseMsg}}
                            </v-alert>
                        </v-card-text>
                    </v-card>
                    <v-flex align-end class="text-md-center my-4 ">
                        <span class="calltxt">Questions? Call 1-866-925-6608</span>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>
<script>
import { mapGetters,mapActions} from "vuex";
import services from "../services/HttpService";
import config from "../config";
export default {
    data: () => ({
        responseMsg:'',
        responseColor:''
    }),
    async created() {
        const self = this,wApp = window.getApp;
        services.get("users/confirm-email?token="+self.$route.query.token).then(res => {
            if (res.data.status) {
                self.responseMsg = res.data.message;
                self.responseColor = config.successMsgColorStr;
            } else {
                self.responseMsg = res.data.message;
                self.responseColor = config.errMsgColorStr;
            }
        })
        .catch(err => {
            self.responseMsg = err.message;
            self.responseColor = config.errMsgColorStr;
        });        
    }
};
</script>
<style lang="css" scoped>
#login {
    height:100%;
    width: 100%;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/ConfirmEmail.vue